import { render } from "./CardsGridSection.vue?vue&type=template&id=1c5eea36&ts=true"
import script from "./CardsGridSection.vue?vue&type=script&lang=ts"
export * from "./CardsGridSection.vue?vue&type=script&lang=ts"

import "./CardsGridSection.vue?vue&type=style&index=0&id=1c5eea36&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__